module.exports = __webpack_public_path__ + "img/home-locate-vending-machines.5d5c9133.png";